export enum EPriceTypes {
    Possess = 1, // Покупка за полную стоимость
    Leasing = 5, // Покупка в рассрочку
}
